import Dexie, { Table } from 'dexie';
import { INDEX_DB1 } from './constant';

export interface ResponsiveContent {
  id?: number;
  contentUuid: string;
  salesChannelUuid: string;
  contentPageUuid: string;
  language: string;
  data: any;
  primaryKey: string;
}

export class IndexDB extends Dexie {
  data!: Table<ResponsiveContent>;

  constructor() {
    super(INDEX_DB1);
    this.version(1).stores({
      data: 'primaryKey,contentPageUuid,contentUuid, salesChannelUuid, language, data',
    });
  }
}

export const db = new IndexDB();
